import React from 'react';

import { Card, Skeleton } from '@mui/material';
import { useTheme } from '@mui/material/styles';

import { checkIsLightTheme } from 'utils/theme';

const getStyles = theme => {
  const { palette } = theme;
  const isLightTheme = checkIsLightTheme(palette.type);

  return {
    card: {
      backgroundColor: isLightTheme ? null : '#0a0a0a',
    },
  };
};

const CardSkeleton = () => {
  const theme = useTheme();
  const styles = getStyles(theme);

  return (
    <Card square className="w-full mb-28 max-h-full flex flex-col py-10 px-5" sx={styles.card}>
      <div className="flex flex-1 justify-between mb-20">
        <Skeleton animation="pulse" variant="text" width="280px" />
        <Skeleton animation="pulse" className="ml-20" variant="text" width="80px" />
      </div>

      <div>
        <Skeleton animation="pulse" height="50px" variant="text" />
        <Skeleton animation="pulse" height="50px" variant="text" />
        <Skeleton animation="pulse" height="50px" variant="text" />
      </div>
    </Card>
  );
};

export default CardSkeleton;
